var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip,
    classes: 'badge-theme',
  }),expression:"{\n    content: tooltip,\n    classes: 'badge-theme',\n  }"}],class:_vm.badgeClass,on:{"click":function($event){$event.preventDefault();return _vm.copyToclip.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"pl-1"},[_vm._t("default")],2),(_vm.copyToClipboard)?[_c('font-awesome-icon',{attrs:{"icon":['fal', 'paste']}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }